var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 7.4501L10.7502 1.3501L0.200195 7.4501V19.6301L10.7502 25.7301L21.3102 19.6301V7.4501Z",
    fill: "#4F80DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38965 23.8099V3.18994C4.38965 3.04994 4.49965 2.93994 4.63965 2.93994H16.3296C16.4696 2.93994 16.5796 3.04994 16.5796 3.18994V23.7499",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.849609 23.8101H20.0996",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62012 3.77005L12.5401 0.760049C12.7001 0.700049 12.8701 0.820049 12.8701 0.990049V26.6C12.8701 26.77 12.7001 26.89 12.5401 26.83L4.62012 23.81V3.77005Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1095 15.17C11.4354 15.17 11.6995 14.9058 11.6995 14.58C11.6995 14.2541 11.4354 13.99 11.1095 13.99C10.7837 13.99 10.5195 14.2541 10.5195 14.58C10.5195 14.9058 10.7837 15.17 11.1095 15.17Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.5876b74f.svg";
export { ForwardRef as ReactComponent };